import { Modal } from '@/components/Layout';
import { Divider } from 'primereact/divider';
import { StatCardProps, User, UserInfoProps } from './user.types';
import { useUsersList } from '@/components/Views/Users/useUsersList';
import { useUsersStore } from '@/store/UsersStore/useUsersStore';
import iconSex from "@/assets/icons/sex.svg"
import iconCall from "@/assets/icons/call.svg"
import iconLocation from "@/assets/icons/location.svg"

const StatCard = ({ icon, label, value }: StatCardProps): JSX.Element => (
  <div className="bg-[#131311] p-5 rounded-lg w-[133px] mr-2.5">
    <div className="h-[44.86px] flex justify-center items-center bg-[#2A240F] w-[44.86px] rounded-md">
      <i className={`pi pi-${icon} text-primary text-lg`}></i>
    </div>
    <Divider
      layout="horizontal"
      className="w-[61.69px] h-[2.24px] bg-primary border border-solid border-primary mt-[27px] mb-0"
    />
    <div className="">
      <span className="text-sm text-[#676767] font-normal block mt-[13px]">
        {label}
      </span>
      <span className="text-[35.89px] font-semibold">{value}</span>
    </div>
  </div>
);

const UserInfo = ({ icon, text }: UserInfoProps): JSX.Element => (
  <li className="flex items-center space-x-2">
    <img src={icon} alt={icon} className="w-5 h-5" />
    <span>{text}</span>
  </li>
);

export const UserDetail: React.FC<{ user: User }> = ({ user }): JSX.Element => {
  const { openUsersModal } = useUsersStore();
  const { isOpenUsersModal } = useUsersList();

  const USER_INFO: UserInfoProps[] = [
    { icon: iconSex, text: user?.gender ?? '' },
    { icon: iconCall, text: user.phoneNumber ?? '' },
    { icon: iconLocation, text: user.region?.name ?? '' },
  ];

  const STATS: StatCardProps[] = [
    { icon: 'wallet', label: 'Ami invité', value: user.invitedBy?.points ?? 0 },
    { icon: 'chart-pie', label: 'Points', value: user.points },
  ];

  return (
    <Modal
      isOpen={isOpenUsersModal}
      onClose={openUsersModal}
      modalStyle="bg-[#2A2A2A] w-[941px] h-[712px]"
      headerStyle="bg-[#2A2A2A] text-white"
    >
      <div className="text-white font-raleway">
        <div className="flex flex-col lg:flex-row">
          <div className="w-full lg:w-1/3 space-y-4">
            <h2 className="text-xl font-bold text-primary">{`${user.firstName} ${user.lastName}`}</h2>
            <p className="text-sm font-normal">{`${user.school?.name ?? ''}`}</p>
            <span className="text-sm font-normal">{`${user.class?.name ?? ''} ${' '} ${user.serie?.name ?? ''}`}</span>
            <p className="flex items-center justify-center bg-bgColor rounded-lg text-primary text-sm text-center font-normal h-[52px]">
              Abonnement par {user.status ?? ''}
            </p>

            <ul className="space-y-2 text-base text-gray-400 pb-10">
              {USER_INFO.map((info, index) => (
                <UserInfo key={index} {...info} />
              ))}
            </ul>

            <div className="flex h-[191px]">
              {STATS.map((stat, index) => (
                <StatCard key={index} {...stat} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
